module.exports = __webpack_public_path__ + "static/media/binder-25.2a854fab.png";